import React, { useState } from 'react';
import { ContactOrganizerButton } from '../../components-redesign/ContactOrganizerButton';
import { FollowOrganizer } from '../../components/FollowOrganizer';
import { Organizer } from '../../types';
import { OrganizerTrustSignals } from './OrganizerTrustSignals';

interface OrganizerDetailsProps {
    organizer?: Organizer;
    totalEvents: number;
    userId: string;
}

export const OrganizerDetails: React.FunctionComponent<
    OrganizerDetailsProps
> = (props) => {
    const { organizer, totalEvents, userId } = props;
    const [followers, setFollowers] = useState(0);

    if (!organizer) {
        return null;
    }

    return (
        <div className="organizer-profile-header__container">
            <div className="organizer-profile-header__container--button-group">
                <ContactOrganizerButton />
                <FollowOrganizer
                    organizer={organizer}
                    userId={userId}
                    renderFollowCount={(followCount: string) => {
                        setFollowers(Number(followCount));
                        return <></>;
                    }}
                />
            </div>
            <OrganizerTrustSignals
                organizer={organizer}
                followCount={followers}
                totalEvents={totalEvents}
            />
        </div>
    );
};
